import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function OfferBanner() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-104">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 28
    }} className="fixed bottom-0 left-0 right-0 z-40 bg-white/95 backdrop-blur-md border-t border-gray-200 shadow-[0_-4px_20px_rgba(0,0,0,0.05)]" data-id="element-105">
          <div className="max-w-2xl mx-auto px-4 py-3 flex items-center justify-between gap-3" data-id="element-106">
            <div className="flex flex-col leading-tight min-w-0" data-id="element-107">
              <span className="text-[10px] sm:text-xs font-bold uppercase tracking-wider text-swiss-blue-expert" data-id="element-108">
                W&R Master-System 2026
              </span>
              <span className="text-sm sm:text-base font-bold text-swiss-charcoal truncate" data-id="element-109">
                Das Lehrsystem für die Schweiz 🇨🇭
              </span>
            </div>
            <div className="flex-1 max-w-[55%] sm:max-w-none" data-id="element-110">
              <CTAButton className="py-2.5 sm:py-3 text-sm sm:text-base" data-id="element-111">
                ANGEBOTE ANSEHEN
              </CTAButton>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}